import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';

import { environment } from '../../../environments/environment';
import { ePrivileges } from '../models';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class PrivilegesGuard implements CanActivate {
  showCreateNewAccountRequest = environment.showCreateNewAccountRequest;
  public deployment = environment.deployment;
  constructor(public router: Router,
    public authService: AuthenticationService) { }
  canActivate(incomingData: ActivatedRouteSnapshot): boolean {
    if (this.authService.hasPrivilege(ePrivileges.SystemAdmin)) {
      return true;
    }
    if (incomingData.data.route === ePrivileges.GeneralVideo) {
      return this.authService.hasPrivilege(ePrivileges.GeneralVideo);
    } else if (incomingData.data.route === ePrivileges.ViewEvents) {
      return this.authService.hasPrivilege(ePrivileges.ViewEvents);
    } else if (incomingData.data.route === ePrivileges.Analytics) {
      return this.authService.hasPrivilege(ePrivileges.Analytics);
    } else if (incomingData.data.route === ePrivileges.GeneralConfig) {
      return this.authService.hasPrivilege(ePrivileges.GeneralConfig);
    } else if (incomingData.data.route === ePrivileges.UserConfig) {
      return this.authService.hasPrivilege(ePrivileges.UserConfig);
    } else if (incomingData.data.route === ePrivileges.RolesConfig) {
      return this.authService.hasPrivilege(ePrivileges.RolesConfig);
    } else if (incomingData.data.route === ePrivileges.NewAccountRequest && this.showCreateNewAccountRequest) {
      return this.authService.hasPrivilege(ePrivileges.NewAccountRequest);
    } else if (incomingData.data.route === ePrivileges.CameraConfig) {
      return this.authService.hasPrivilege(ePrivileges.CameraConfig);
    } else if (incomingData.data.route === ePrivileges.Alerts) {
      return this.authService.hasPrivilege(ePrivileges.Alerts);
    } else if (incomingData.data.route === ePrivileges.UserGroupConfig) {
      return this.authService.hasPrivilege(ePrivileges.UserGroupConfig);
    } else if (incomingData.data.route === ePrivileges.VDSConfig) {
      return this.authService.hasPrivilege(ePrivileges.VDSConfig);
    } else if (incomingData.data.route === ePrivileges.WallTourViewOrConfig) {
      return this.authService.hasPrivilege(ePrivileges.WallTourConfig) ||
        this.authService.hasPrivilege(ePrivileges.WallTourView);
    } else if (incomingData.data.route === ePrivileges.WallViewOrConfig) {
      return this.authService.hasPrivilege(ePrivileges.CameraWallConfig) ||
        this.authService.hasPrivilege(ePrivileges.CameraWallView);
    } else if (incomingData.data.route === ePrivileges.CameraTourViewOrConfig) {
      return this.authService.hasPrivilege(ePrivileges.CameraTourConfig) ||
        this.authService.hasPrivilege(ePrivileges.CameraTourView);
    }
  }
}
